import * as yup from 'yup';

export const formClaimSchema = yup.object().shape({
  service_window_reference_id: yup.string().optional(),
  nte_accepted: yup.boolean().default(false).optional(),
  nte_amount_in_cents: yup.number().optional(),
});

export type FormState = yup.InferType<typeof formClaimSchema>;

export const CLAIM_REQUEST_SCREEN_KEYS = {
  REVIEW_AND_CONFIRM: 'review-and-confirm',
  SELECT_SCHEDULE: 'select-schedule',
  CLAIM_SUCCESS: 'claim-success',
} as const;

export type ClaimRequestKey =
  (typeof CLAIM_REQUEST_SCREEN_KEYS)[keyof typeof CLAIM_REQUEST_SCREEN_KEYS];

export type PassRequestScreenData = {
  TITLE: string;
  DESCRIPTION: string;
  HIDE_SUBMIT: boolean;
  SUBMIT_LABEL: string;
  HIDE_BACK: boolean;
  BACK_LABEL: string;
  BACK_STYLE: string;
  HIDE_HEADER: boolean;
  HIDE_FOOTER: boolean;
};

export const CLAIM_REQUEST_TAB_DATA: Record<ClaimRequestKey, PassRequestScreenData> = {
  [CLAIM_REQUEST_SCREEN_KEYS.REVIEW_AND_CONFIRM]: {
    TITLE: 'Review & Confirm Details',
    DESCRIPTION: '',
    HIDE_SUBMIT: false,
    SUBMIT_LABEL: 'Next',
    HIDE_BACK: false,
    BACK_LABEL: 'Back',
    BACK_STYLE: 'has-secondary',
    HIDE_HEADER: false,
    HIDE_FOOTER: false,
  },
  [CLAIM_REQUEST_SCREEN_KEYS.SELECT_SCHEDULE]: {
    TITLE: 'Select Schedule',
    DESCRIPTION: '',
    HIDE_SUBMIT: false,
    SUBMIT_LABEL: 'Claim Work Order',
    HIDE_BACK: false,
    BACK_LABEL: 'Back',
    BACK_STYLE: 'has-secondary',
    HIDE_HEADER: false,
    HIDE_FOOTER: false,
  },
  [CLAIM_REQUEST_SCREEN_KEYS.CLAIM_SUCCESS]: {
    TITLE: 'Work Order Passed',
    DESCRIPTION: 'It will appear in your work orders list',
    HIDE_SUBMIT: true,
    SUBMIT_LABEL: '',
    HIDE_BACK: false,
    BACK_LABEL: 'View Work Order Details',
    BACK_STYLE: 'has-secondary',
    HIDE_HEADER: true,
    HIDE_FOOTER: false,
  },
};
